export const TestResultSectionDataP632 = (selectedTag, formData) => ({
    rows: [
        {
            key: 1,
            fields: [
                {
                    key: 'F143HmireadingAfterTestLabel',
                    label: 'HMI Reading after Test',
                    xs: 2,
                    height: '1.2rem',
                    padding: '5px 0 0 0',
                    isLabel: 'true',
                    labelWidth: '96%',
                    textAlign: 'left',
                    fontSize: '9pt',
                    fontWeight: '600',
                },
                {
                    key: 'F143HmireadingAfterTest',
                    value: formData.F143HmireadingAfterTest,
                    xs: 2,
                    isRequired: true,
                    type: 'number',
                    maxLength: '10',
                    labelWidth: '0',
                    width: '100%',
                    height: '1.2rem',
                    textAlign: 'center'
                },
                {
                    key: 'NoDataP63',
                    xs: 1,
                    isLabel: true,
                },
                {
                    key: 'F267ProcessTxreadingAfterTestLabel',
                    label: 'Process TX Reading after Test',
                    xs: 3,
                    padding: '5px 0 0 0',
                    isLabel: 'true',
                    labelWidth: '98%',
                    textAlign: 'end',
                    fontSize: '9pt',
                    fontWeight: '600',
                },
                {
                    key: 'F267ProcessTxreadingAfterTest',
                    value: formData.F267ProcessTxreadingAfterTest,
                    isRequired: true,
                    type: 'number',
                    maxLength: '10',
                    xs: 4,
                    labelWidth: '0',
                    width: '100%',
                    height: '1.2rem',
                    textAlign: 'center',
                    marginLeft: '0.8px'
                }]
        }]

});
